import DependantsProtectionClient from '@master/model/kyc-form/need-analysis/protection/DependantsProtectionClient'

export default class CustomDependantsProtectionClient extends DependantsProtectionClient {
  setupDefaultRate (inDefaultRate: number) {
    this.defaultRate = inDefaultRate
  }
}
